import { Component, Inject } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { ActualDate2Change } from '../../shared/misc-classes';

@Component({
  selector: 'actual-date-dialog2',
  templateUrl: 'actual-date-dialog2.html'
})
export class ActualDateDialog2 {

  constructor(
    public dialogRef: MatDialogRef<ActualDateDialog2>,
    @Inject(MAT_DIALOG_DATA) public data: ActualDate2Change) {
     }

  onNoClick(): void {
    this.dialogRef.close();
  }

}